import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { apiUrl } from '../../../../../utils/url';
import ErrorMessage from '../../../../errors/errorMessage';
import { createFormdataValues } from '../../../../../utils/createFormdataValues';
import { hideLoader, showLoader } from '../../../../loader';
import arrowIcon from '../../../../../assets/img/diagonal-arrow.svg';
import downloadIcon from '../../../../../assets/img/download.svg';
import sheetsIcon from '../../../../../assets/img/google-sheets.svg';
import instantlyIcon from '../../../../../assets/img/instantly.svg';
import smartleadIcon from '../../../../../assets/img/smartlead.svg';
import hubspotIcon from '../../../../../assets/img/hubspot.svg';

const ExportToModal = ({ show, setShow, exportToSteps, exportCSV }) => {
    const [error, setError] = useState([]);
    const [value, setValue] = useState({});
    const { slug } = useSelector(state => state?.slugReducer);
    const handleClose = () => {
        setValue(null);
        setShow(null);
    }
    
    const showNextExportStep = (type,heading) => {
        if (type === 'csv') {
            exportCSV()
            setShow({step:0})
        }else{
            setShow({step:2,export_to:type,heading:heading})
        }
    };
    return (
        <Modal centered show={show} onHide={handleClose} className="rename-modal">
            <div class="modal-content pt-0 pl-0 pr-0 pb-0 border-0 ">
                <div class="modal-header">
                    Export 3 Leads
                    <button type="button" class="close" onClick={handleClose} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body ps-0 pe-0 export-to-modal-body">
                    <ErrorMessage error={error} />
                    <div className='export-to-main' onClick={() => showNextExportStep('csv')}>
                        <span className='d-flex align-items-center gap-2 justify-content-start'>
                            <span>
                                <img src={downloadIcon} alt="" />
                            </span>
                            <span>
                                Download CSV
                            </span>
                        </span>
                        <span>
                            <img src={arrowIcon} alt="" />
                        </span>
                    </div>
                    <div className='export-to-main' onClick={() => showNextExportStep('google_sheets','Send to Google Sheets')}>
                        <span className='d-flex align-items-center gap-2 justify-content-start'>
                            <span>
                                <img src={sheetsIcon} alt="" />
                            </span>
                            <span>
                                Send to Google Sheets
                            </span>
                        </span>
                        <span>
                            <img src={arrowIcon} alt="" />
                        </span>
                    </div>
                    <div className='export-to-main'  onClick={() => showNextExportStep('instantly','Add Instantly Account')}>
                        <span className='d-flex align-items-center gap-2 justify-content-start'>
                            <span>
                                <img src={instantlyIcon} alt="" />
                            </span>
                            <span>
                                Send to Instantly
                            </span>
                        </span>
                        <span>
                            <img src={arrowIcon} alt="" />
                        </span>
                    </div>
                    <div className='export-to-main disabled'>
                        <span className='d-flex align-items-center gap-2 justify-content-start'>
                            <span>
                                <img src={smartleadIcon} alt="" />
                            </span>
                            <span>
                                Send to Smartlead.ai
                            </span>
                        </span>
                        <span className='f3f3f3-btn'>
                            Coming Soon
                        </span>
                    </div>
                    <div className='export-to-main disabled'>
                        <span className='d-flex align-items-center gap-2 justify-content-start'>
                            <span>
                                <img src={hubspotIcon} alt="" />
                            </span>
                            <span className='box-grey'>
                            Send to Hubspot
                            </span>
                        </span>
                        <span className='f3f3f3-btn'>
                            Coming Soon
                        </span>
                    </div>

                </div>
            </div>
        </Modal>
    )
}

export default ExportToModal